import type { AgeCriteria } from '@/types/filterEnumTypes';
import { AgeFilter } from '@/types/searchFilterTypes';
import { RuleProperties } from '@react-awesome-query-builder/mui';
import { FilterMapper } from './filterMapperTypes';

export const AgeMapper: FilterMapper = {
  checkIsIncomplete(properties) {
    const ageValue = properties.value[0];
    const isNoAgeSelected = ageValue === undefined || ageValue?.value == null;
    return isNoAgeSelected;
  },

  toFilter(props: RuleProperties): AgeFilter {
    if (!props.value) throw new Error('Missing value');
    if (!props.operator) throw new Error('Missing operator');
    if (props.value.length !== 1) throw new Error('Invalid value. Expected array of length 1');

    const value = props.value[0] as unknown as AgeCriteria;
    return { name: 'age', value: value.value, range: props.operator } as AgeFilter;
  },

  async fromFilter(filter: AgeFilter) {
    return {
      field: filter.name,
      operator: filter.range,
      value: [{ value: filter.value }],
    };
  },
};
